import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, DoBootstrap, Injector, NgModule, inject } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { BrowserModule } from '@angular/platform-browser';
import { ProgressBarModule } from '@mosaik/angular';
import { BusyService } from '@mosaik/presentation';
import { SurveyResultComponent } from '../components/survey-result/survey-result.component';
import { SurveyService } from '../services/survey.service';
import { TranslateModule } from '@ngx-translate/core';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  imports: [CommonModule, BrowserModule, ProgressBarModule, TranslateModule.forRoot(), HttpClientModule],
  declarations: [SurveyResultComponent],
  providers: [SurveyService, BusyService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SurveyElementModule implements DoBootstrap {
  private readonly injector = inject(Injector);

  public ngDoBootstrap(): void {
    const element = createCustomElement(SurveyResultComponent, {
      injector: this.injector
    });
    customElements.define('survey-result-view', element);
  }
}
